<template>
  <div class="admin-layout">
    <div class="top-bar">
      <div class="top-bar-content">
        <div class="page-title">{{ pageTitle }}</div>
      </div>
    </div>
    <div v-if="!isCollapse && isMobile" class="sidebar-mask" @click="toggleSidebar"></div>
    <el-container>
      <el-aside 
        class="sidebar-container" 
        :style="sidebarStyle">
        <div class="sidebar-header">
          <div class="logo-wrapper">
            <div class="logo">托管</div>
          </div>
          <div class="title-wrapper">
            <div class="school-title">托管中心</div>
            <div class="module-title">管理中心</div>
          </div>
        </div>
        
        <div class="sidebar-nav">
          <div class="nav-group">
            <div class="nav-group-title">管理导航</div>
            <el-menu
              :default-active="activeMenu"
              class="sidebar-menu"
              router
              :collapse="isCollapse"
              background-color="#fff"
              text-color="#303133"
              active-text-color="#4f46e5"
              @select="handleMenuSelect">
              <el-menu-item :index="getRoutePath('')">
                <i class="el-icon-s-home"></i>
                <span slot="title">管理主页</span>
              </el-menu-item>
              
              <el-submenu index="users">
                <template slot="title">
                  <i class="el-icon-user"></i>
                  <span>用户管理</span>
                </template>
                <el-menu-item :index="getRoutePath('users/teachers')">
                  <i class="el-icon-s-custom"></i>
                  <span>教师管理</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('users/students')">
                  <i class="el-icon-reading"></i>
                  <span>学生管理</span>
                </el-menu-item>
              </el-submenu>
              
              <el-menu-item :index="getRoutePath('classes')">
                <i class="el-icon-menu"></i>
                <span slot="title">班级管理</span>
              </el-menu-item>
              
              <el-menu-item :index="getRoutePath('activities')">
                <i class="el-icon-date"></i>
                <span slot="title">活动管理</span>
              </el-menu-item>
              
              <el-menu-item :index="getRoutePath('notifications')">
                <i class="el-icon-message"></i>
                <span slot="title">通知管理</span>
              </el-menu-item>
              
              <el-menu-item :index="getRoutePath('evaluations')">
                <i class="el-icon-star-on"></i>
                <span slot="title">评分管理</span>
              </el-menu-item>
              
              <el-submenu index="attendance">
                <template slot="title">
                  <i class="el-icon-time"></i>
                  <span>出勤管理</span>
                </template>
                <el-menu-item :index="getRoutePath('attendance/history')">
                  <i class="el-icon-notebook-1"></i>
                  <span>历史考勤(班级)</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('attendance/today')">
                  <i class="el-icon-timer"></i>
                  <span>今日考勤(班级)</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('attendance/teacher')">
                  <i class="el-icon-s-custom"></i>
                  <span>教师考勤</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item :index="getRoutePath('document')">
                <i class="el-icon-folder"></i>
                <span slot="title">文库管理</span>
              </el-menu-item>
              
              <el-submenu index="data-monitor">
                <template slot="title">
                  <i class="el-icon-data-analysis"></i>
                  <span>数据监控</span>
                </template>
                <el-menu-item :index="getRoutePath('data-monitor/login')">
                  <i class="el-icon-monitor"></i>
                  <span>登录数据(家长)</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('data-monitor/teachers')">
                  <i class="el-icon-s-custom"></i>
                  <span>操作数据(教师)</span>
                </el-menu-item>
              </el-submenu>
              
              <el-submenu index="question-bank">
                <template slot="title">
                  <i class="el-icon-notebook-2"></i>
                  <span>题库系统</span>
                </template>
                <el-menu-item :index="getRoutePath('question-bank/questions')">
                  <i class="el-icon-collection"></i>
                  <span>题库管理</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('question-bank/questions-manage')">
                  <i class="el-icon-tickets"></i>
                  <span>题目管理</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('question-bank/subjects')">
                  <i class="el-icon-reading"></i>
                  <span>学科管理</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('question-bank/question-types')">
                  <i class="el-icon-document"></i>
                  <span>题目类型管理</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('question-bank/knowledge-points')">
                  <i class="el-icon-help"></i>
                  <span>知识点管理</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('question-bank/question-creators')">
                  <i class="el-icon-user"></i>
                  <span>录题人员管理</span>
                </el-menu-item>
                <el-menu-item :index="getRoutePath('question-bank/question-viewers')">
                  <i class="el-icon-view"></i>
                  <span>查看人员管理</span>
                </el-menu-item>
              </el-submenu>
              
              <el-menu-item :index="getRoutePath('settings')">
                <i class="el-icon-setting"></i>
                <span slot="title">系统设置</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </el-aside>
      
      <el-container class="main-container" :style="mainContainerStyle">
        <el-header height="60px" class="header">
          <div class="header-left">
            <i 
              :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" 
              class="collapse-btn"
              @click="toggleSidebar"></i>
          </div>
          <div class="header-right">
            <div class="notification-container">
              <el-badge :value="unreadReservationCount" :hidden="unreadReservationCount === 0" class="notification-badge">
                <el-button type="text" class="notification-btn" @click="showReservationDialog">
                  <i class="el-icon-bell"></i>
                </el-button>
              </el-badge>
            </div>
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="avatar-container">
                <el-avatar :size="32" :src="userAvatar" icon="el-icon-user-solid"></el-avatar>
                <span class="name">{{ userName }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="profile">个人信息</el-dropdown-item>
                <el-dropdown-item command="phone">更新手机号</el-dropdown-item>
                <el-dropdown-item command="password">修改密码</el-dropdown-item>
                <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        
        <el-main class="main-content">
          <router-view />
        </el-main>
        
        <el-footer height="40px" class="footer">
          <div class="footer-content">
            <span>© {{ currentYear }} 校园管理系统</span>
          </div>
        </el-footer>
      </el-container>
    </el-container>
    
    <!-- 个人信息对话框 -->
    <el-dialog title="个人信息" :visible.sync="profileDialogVisible" width="500px">
      <div v-if="userProfile" class="profile-container">
        <div class="profile-header">
          <el-avatar :size="80" :src="userProfile.avatar" icon="el-icon-user-solid"></el-avatar>
          <div class="profile-name">{{ userProfile.username }}</div>
        </div>
        
        <el-divider></el-divider>
        
        <div class="profile-info">
          <div class="info-item">
            <span class="info-label">手机号码：</span>
            <span class="info-value">{{ userProfile.phone || '未设置' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">性别：</span>
            <span class="info-value">{{ formatGender(userProfile.gender) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">角色：</span>
            <span class="info-value">{{ formatRole(userProfile.role_id) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">状态：</span>
            <span class="info-value">
              <el-tag :type="userProfile.status === 1 ? 'success' : 'danger'" size="mini">
                {{ userProfile.status === 1 ? '正常' : '禁用' }}
              </el-tag>
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">最后登录：</span>
            <span class="info-value">{{ formatDate(userProfile.last_login_time) }}</span>
          </div>
        </div>
        
        <el-divider>校区信息</el-divider>
        
        <div v-if="userProfile.campus_info && userProfile.campus_info.length > 0" class="campus-list">
          <div v-for="(campus, index) in userProfile.campus_info" :key="index" class="campus-item">
            <div class="campus-name">
              <span>{{ campus.campus_name }}</span>
              <el-tag v-if="campus.is_main === 1" size="mini" type="primary">主校区</el-tag>
            </div>
            <div class="campus-detail">
              <div class="detail-item">
                <i class="el-icon-location"></i>
                <span>{{ campus.address }}</span>
              </div>
              <div class="detail-item">
                <i class="el-icon-phone"></i>
                <span>{{ campus.contact_phone }}</span>
              </div>
              <div class="detail-item">
                <i class="el-icon-star-on"></i>
                <span>{{ campus.star_level }}星级</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-campus">暂无校区信息</div>
      </div>
      
      <div v-else class="profile-loading">
        <el-skeleton :rows="6" animated />
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="profileDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    
    <!-- 引入修改密码组件 -->
    <password-dialog v-model="passwordDialogVisible" :user-profile="userProfile" @password-changed="handlePasswordChanged"></password-dialog>
    
    <!-- 引入更新手机号组件 -->
    <phone-dialog v-model="phoneDialogVisible" :user-profile="userProfile" @phone-updated="handlePhoneUpdated"></phone-dialog>
    
    <!-- 预约通知对话框 -->
    <el-dialog :title="dialogTitle || '预约通知'" :visible.sync="reservationDialogVisible" width="600px">
      <div class="reservation-container">
        <div v-if="loading" class="reservation-loading">
          <el-skeleton :rows="6" animated />
        </div>
        
        <div v-else-if="pendingReservations.length === 0" class="empty-reservation">
          <i class="el-icon-chat-dot-round"></i>
          <p>暂无未处理的预约通知</p>
        </div>
        
        <div v-else class="reservation-list">
          <div v-for="item in pendingReservations" :key="item.reservation_id" class="reservation-item">
            <div class="reservation-header">
              <div class="left">
                <h3>{{ item.class_name }}</h3>
                <div class="reservation-tags">
                  <el-tag size="small" type="primary">{{ item.class_type }}</el-tag>
                  <el-tag size="small" type="success">{{ item.grade }}</el-tag>
                </div>
              </div>
              <div class="right" v-if="!dialogTitle || dialogTitle !== '全部预约信息'">
                <el-button size="mini" type="primary" @click="handleProcessReservation(item)">处理</el-button>
              </div>
            </div>
            
            <div class="reservation-content">
              <div class="reservation-info">
                <div class="info-item">
                  <span class="info-label">家长姓名:</span>
                  <span class="info-value">{{ item.parent_name }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">联系电话:</span>
                  <span class="info-value">{{ item.parent_phone }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">预约时间:</span>
                  <span class="info-value">{{ item.create_time }}</span>
                </div>
                <div class="info-item" v-if="item.remark">
                  <span class="info-label">备注:</span>
                  <span class="info-value">{{ item.remark }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="reservationDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="showAllReservations">查看全部预约信息</el-button>
      </div>
    </el-dialog>
    
    <!-- 处理预约对话框 -->
    <el-dialog title="处理预约" :visible.sync="processDialogVisible" width="400px" :close-on-click-modal="false">
      <el-form :model="processForm" ref="processForm" label-width="80px">
        <el-form-item label="备注信息" prop="process_remark">
          <el-input
            type="textarea"
            v-model="processForm.process_remark"
            :rows="3"
            placeholder="请输入处理备注信息"
          ></el-input>
        </el-form-item>
      </el-form>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="processDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmProcessReservation" :loading="processingReservation">确认处理</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import PasswordDialog from '@/components/PasswordDialog.vue';
import PhoneDialog from '@/components/PhoneDialog.vue';

export default {
  name: 'AdminLayout',
  components: {
    PasswordDialog,
    PhoneDialog
  },
  data() {
    return {
      isMobile: false,
      profileDialogVisible: false,
      passwordDialogVisible: false,
      phoneDialogVisible: false,
      userProfile: null,
      reservationDialogVisible: false,
      processDialogVisible: false,
      loading: true,
      pendingReservations: [],
      currentReservation: null,
      processForm: {
        process_remark: ''
      },
      processingReservation: false,
      unreadReservationCount: 0,
      unreadCountTimer: null,
      campusCode: null,
      routeGuard: null,
      dialogTitle: null
    };
  },
  computed: {
    ...mapGetters({
      isCollapse: 'isCollapse',
      userName: 'auth/userName',
      userAvatar: 'auth/userAvatar'
    }),
    activeMenu() {
      return this.$route.path;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    pageTitle() {
      const route = this.$route;
      return route.meta && route.meta.title ? route.meta.title : '管理中心';
    },
    sidebarStyle() {
      if (this.isMobile) {
        return {
          transform: this.isCollapse ? 'translateX(-210px)' : 'translateX(0)'
        };
      }
      return {
        transform: 'translateX(0)'
      };
    },
    mainContainerStyle() {
      if (this.isMobile) {
        return {
          marginLeft: '0'
        };
      }
      return {
        marginLeft: '210px'
      };
    }
  },
  methods: {
    ...mapActions(['toggleSidebar']),
    handleCommand(command) {
      switch (command) {
        case 'profile':
          this.showProfile();
          break;
        case 'phone':
          this.showPhoneDialog();
          break;
        case 'password':
          this.showPasswordDialog();
          break;
        case 'logout':
          this.logout();
          break;
      }
    },
    
    // 显示手机更新对话框
    showPhoneDialog() {
      // 确保已获取用户资料
      if (!this.userProfile) {
        this.showProfile().then(() => {
          this.phoneDialogVisible = true;
        });
      } else {
        this.phoneDialogVisible = true;
      }
    },
    
    // 处理手机号更新成功
    handlePhoneUpdated(newPhone) {
      // 更新用户资料中的手机号
      if (this.userProfile) {
        this.userProfile.phone = newPhone;
      }
      this.$message.success('手机号已更新为：' + newPhone);
      
      // 手机号更新成功后，延迟1.5秒自动登出
      setTimeout(() => {
        this.$message.info('手机号已更新，请重新登录');
        this.logout();
      }, 1500);
    },
    
    // 显示密码修改对话框
    showPasswordDialog() {
      // 确保已获取用户资料，这样组件可以获取到手机号以发送验证码
      if (!this.userProfile) {
        this.showProfile().then(() => {
          this.passwordDialogVisible = true;
        });
      } else {
        this.passwordDialogVisible = true;
      }
    },
    
    // 处理密码修改成功
    handlePasswordChanged() {
      // 密码修改成功后自动登出
      setTimeout(() => {
        this.logout();
      }, 1500);
    },
    
    async showProfile() {
      this.profileDialogVisible = true;
      this.userProfile = null;
      
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('/api/v1/profile/info', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.data && response.data.code === 200) {
          this.userProfile = response.data.data;
          console.log('个人资料:', this.userProfile);
        } else {
          this.$message.error('获取个人信息失败：' + (response.data.msg || '未知错误'));
        }
      } catch (error) {
        console.error('获取个人信息失败:', error);
        this.$message.error('获取个人信息失败，请稍后重试');
      }
    },
    
    formatGender(gender) {
      const genderMap = {
        0: '未知',
        1: '男',
        2: '女'
      };
      return genderMap[gender] || '未知';
    },
    
    formatRole(roleId) {
      const roleMap = {
        1: '超级管理员',
        2: '校区管理员',
        3: '教师',
        4: '学生',
        5: '家长'
      };
      return roleMap[roleId] || '未知角色';
    },
    
    formatDate(dateStr) {
      if (!dateStr) return '未登录';
      
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) return dateStr;
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      } catch (error) {
        return dateStr;
      }
    },
    
    logout() {
      // 获取当前学校代码
      const schoolCode = this.$route.params.schoolCode || localStorage.getItem('schoolCode') || '';
      
      this.$store.dispatch('auth/logout').then(() => {
        if (schoolCode && schoolCode !== 'undefined') {
          this.$router.push(`/${schoolCode}/login`);
        } else {
          this.$router.push('/login');
        }
      });
    },
    getRoutePath(path) {
      const schoolCode = this.$route.params.schoolCode || localStorage.getItem('schoolCode') || '';
      const campusCode = this.$route.params.campusCode;
      
      // 获取校区代码，首先从路由参数获取，如果没有则从本地存储获取
      let campusCodeValue = campusCode;
      if (!campusCodeValue) {
        const campusInfo = localStorage.getItem('currentCampus');
        if (campusInfo) {
          try {
            const parsedInfo = JSON.parse(campusInfo);
            campusCodeValue = parsedInfo.code;
          } catch (e) {
            console.error('解析校区信息失败:', e);
          }
        }
      }
      
      if (schoolCode && schoolCode !== 'undefined') {
        if (campusCodeValue && campusCodeValue !== 'undefined') {
          // 如果有校区代码，则使用 /schoolCode/campusCode/admin/path 格式
          return path ? `/${schoolCode}/${campusCodeValue}/admin/${path}` : `/${schoolCode}/${campusCodeValue}/admin`;
        } else {
          // 向后兼容，如果没有校区代码，则使用 /schoolCode/admin/path 格式
          return path ? `/${schoolCode}/admin/${path}` : `/${schoolCode}/admin`;
        }
      }
      
      // 如果都没有，则使用基础路径
      return path ? `/admin/${path}` : `/admin`;
    },
    checkScreenSize() {
      const oldIsMobile = this.isMobile;
      this.isMobile = window.innerWidth < 768;
      
      if (oldIsMobile !== this.isMobile) {
        this.$store.dispatch('toggleSidebar', this.isMobile);
      }
    },
    handleMenuSelect() {
      if (this.isMobile && !this.isCollapse) {
        this.$store.dispatch('toggleSidebar', true);
      }
    },
    async showReservationDialog() {
      this.reservationDialogVisible = true;
      this.loading = true;
      this.pendingReservations = [];
      this.dialogTitle = '预约通知';
      
      try {
        const campusCode = this.getCampusCode();
        if (!campusCode) {
          this.$message.error('未找到校区信息');
          this.loading = false;
          return;
        }
        
        const token = localStorage.getItem('token');
        const response = await axios.get(`/api/v1/campus/reservations/pending?campus_code=${campusCode}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.data && response.data.code === 200) {
          this.pendingReservations = response.data.data.items || [];
          this.unreadReservationCount = response.data.data.total || 0;
        } else {
          this.$message.error('获取预约通知失败：' + (response.data.msg || '未知错误'));
        }
      } catch (error) {
        console.error('获取预约通知失败:', error);
        this.$message.error('获取预约通知失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    handleProcessReservation(item) {
      this.currentReservation = item;
      this.processForm.process_remark = '';
      this.processDialogVisible = true;
    },
    
    async confirmProcessReservation() {
      if (!this.currentReservation) {
        this.$message.error('预约信息不存在');
        return;
      }
      
      this.processingReservation = true;
      
      try {
        const campusCode = this.getCampusCode();
        if (!campusCode) {
          this.$message.error('未找到校区信息');
          this.processingReservation = false;
          return;
        }
        
        const token = localStorage.getItem('token');
        const response = await axios.post(`/api/v1/campus/reservations/${this.currentReservation.reservation_id}/process`, {
          process_remark: this.processForm.process_remark
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
          params: {
            campus_code: campusCode
          }
        });
        
        if (response.data && response.data.code === 200) {
          this.$message.success('预约处理成功');
          this.processDialogVisible = false;
          await this.showReservationDialog(); // 刷新预约列表
          await this.fetchUnreadReservationCount(); // 刷新未读计数
        } else {
          this.$message.error('预约处理失败：' + (response.data.msg || '未知错误'));
        }
      } catch (error) {
        console.error('预约处理失败:', error);
        this.$message.error('预约处理失败，请稍后重试');
      } finally {
        this.processingReservation = false;
      }
    },
    
    async showAllReservations() {
      const campusCode = this.getCampusCode();
      if (!campusCode) {
        this.$message.error('未找到校区信息');
        return;
      }
      
      this.loading = true;
      this.pendingReservations = [];
      
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`/api/v1/campus/reservations?campus_code=${campusCode}`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.data && response.data.code === 200) {
          this.pendingReservations = response.data.data.items || [];
          this.$set(this, 'dialogTitle', '全部预约信息');
        } else {
          this.$message.error('获取全部预约信息失败：' + (response.data.msg || '未知错误'));
        }
      } catch (error) {
        console.error('获取全部预约信息失败:', error);
        this.$message.error('获取全部预约信息失败，请稍后重试');
      } finally {
        this.loading = false;
      }
    },
    
    getCampusCode() {
      // 获取校区代码，首先从路由参数获取，如果没有则从本地存储获取
      let campusCode = this.$route.params.campusCode;
      if (!campusCode) {
        const campusInfo = localStorage.getItem('currentCampus');
        if (campusInfo) {
          try {
            const parsedInfo = JSON.parse(campusInfo);
            campusCode = parsedInfo.code;
          } catch (e) {
            console.error('解析校区信息失败:', e);
          }
        }
      }
      
      if (!campusCode) {
        campusCode = localStorage.getItem('campusCode');
      }
      
      return campusCode;
    },
    
    async fetchUnreadReservationCount() {
      console.log('开始获取未读预约数量...');
      try {
        const campusCode = this.getCampusCode();
        if (!campusCode) {
          console.error('未找到校区信息');
          return;
        }
        
        console.log(`正在请求未读预约数量 - 校区代码: ${campusCode}`);
        const token = localStorage.getItem('token');
        const response = await axios.get(`/api/v1/campus/reservations/pending?campus_code=${campusCode}&limit=1`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (response.data && response.data.code === 200) {
          const prevCount = this.unreadReservationCount;
          this.unreadReservationCount = response.data.data.total || 0;
          console.log(`未读预约数量更新: ${prevCount} -> ${this.unreadReservationCount}`);
        } else {
          console.error('获取未读预约数量失败:', response.data);
        }
      } catch (error) {
        console.error('获取未读预约数量失败:', error);
      }
    },
  },
  created() {
    // 从路由参数或本地存储获取校区代码
    const campusCode = this.$route.params.campusCode || localStorage.getItem('campusCode');
    this.campusCode = campusCode;
    console.log('当前校区代码:', campusCode);
    
    // 注册全局导航守卫，在每次路由变化后获取通知数量
    this.routeGuard = this.$router.afterEach((to, from) => {
      console.log('【全局路由守卫】路由变化:', from.path, '->', to.path);
      // 路由变化后获取未读预约通知数量
      this.fetchUnreadReservationCount();
    });
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
    
    if (this.isMobile) {
      if (!this.isCollapse) {
        this.$store.dispatch('toggleSidebar', true);
      }
    } else {
      if (this.isCollapse) {
        this.$store.dispatch('toggleSidebar', false);
      }
    }
    
    // 获取未读预约通知数量
    this.fetchUnreadReservationCount();
    
    // 设置定时器，每隔5分钟获取一次未读通知数量
    this.unreadCountTimer = setInterval(() => {
      this.fetchUnreadReservationCount();
    }, 5 * 60 * 1000); // 5分钟
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
    
    // 清除定时器
    if (this.unreadCountTimer) {
      clearInterval(this.unreadCountTimer);
    }
    
    // 移除全局导航守卫
    if (this.routeGuard) {
      this.routeGuard(); // 调用afterEach返回的函数，移除全局导航守卫
    }
  },
  watch: {
    '$route'(to, from) {
      // 记录路由变化日志，便于调试
      console.log('路由变化:', from.path, '->', to.path);
      
      if (this.isMobile && !this.isCollapse) {
        this.$store.dispatch('toggleSidebar', true);
      }
      
      // 路由变化时重新获取未读预约通知数量
      this.fetchUnreadReservationCount();
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-layout {
  height: 100vh;
  width: 100%;
  overflow: auto;
  
  .top-bar {
    height: 40px;
    background: linear-gradient(to right, #4f46e5, #7e22ce);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    
    .top-bar-content {
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0 20px;
      
      .page-title {
        color: white;
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  
  .sidebar-mask {
    position: fixed;
    top: 40px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 998;
  }
   
  .sidebar-container {
    width: 210px !important;
    background-color: #fff;
    height: calc(100vh - 40px);
    position: fixed;
    top: 40px;
    left: 0;
    z-index: 999;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    overflow-y: auto;
    
    .sidebar-header {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 15px;
      border-bottom: 1px solid #f0f0f0;
      
      .logo-wrapper {
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #4f46e5;
        color: white;
        border-radius: 4px;
        margin-right: 10px;
        font-weight: bold;
      }
      
      .title-wrapper {
        display: flex;
        flex-direction: column;
        
        .school-title {
          font-size: 16px;
          font-weight: 500;
          color: #303133;
        }
        
        .module-title {
          font-size: 12px;
          color: #909399;
        }
      }
    }
    
    .sidebar-nav {
      padding: 10px;
      
      .nav-group {
        margin-bottom: 15px;
        
        .nav-group-title {
          font-size: 12px;
          color: #909399;
          padding: 10px 15px;
        }
        
        .sidebar-menu {
          border-right: none;
        }
      }
    }
  }
  
  .main-container {
    margin-left: 210px;
    min-height: 100vh;
    margin-top: 40px;
    
    .header {
      background-color: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.07);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      
      .header-left {
        display: flex;
        align-items: center;
        
        .collapse-btn {
          font-size: 20px;
          cursor: pointer;
          color: #606266;
          margin-right: 20px;
          
          &:hover {
            color: #409EFF;
          }
        }
      }
      
      .header-right {
        display: flex;
        align-items: center;
        
        .notification-container {
          margin-right: 20px;
        }
        .avatar-container {
          display: flex;
          align-items: center;
          cursor: pointer;
          
          .name {
            margin: 0 8px;
            font-size: 14px;
          }
        }
      }
    }
    
    .main-content {
      padding: 20px;
      background-color: #f5f7fa;
    }
    
    .footer {
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: 1px solid #e6e6e6;
      
      .footer-content {
        color: #606266;
        font-size: 12px;
      }
    }
  }
  
  @media (max-width: 768px) {
    .main-container {
      margin-left: 0 !important;
    }
  }
}

.profile-container {
  padding: 10px;
  
  .profile-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
    
    .profile-name {
      margin-top: 15px;
      font-size: 18px;
      font-weight: bold;
      color: #303133;
    }
  }
  
  .profile-info {
    .info-item {
      display: flex;
      margin-bottom: 15px;
      font-size: 14px;
      
      .info-label {
        width: 100px;
        color: #909399;
        flex-shrink: 0;
      }
      
      .info-value {
        color: #303133;
        word-break: break-word;
      }
    }
  }
  
  .campus-list {
    .campus-item {
      margin-bottom: 20px;
      padding: 15px;
      border-radius: 4px;
      background-color: #f8f9fa;
      
      .campus-name {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        font-weight: bold;
        
        span {
          margin-right: 10px;
        }
      }
      
      .campus-detail {
        .detail-item {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          font-size: 13px;
          color: #606266;
          
          i {
            margin-right: 5px;
            color: #909399;
          }
        }
      }
    }
  }
  
  .no-campus {
    text-align: center;
    padding: 20px 0;
    color: #909399;
    font-size: 14px;
  }
}

.profile-loading {
  padding: 20px;
}

.avatar-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  
  .name {
    margin: 0 8px;
    font-size: 14px;
  }
}

.reservation-container {
  padding: 20px;
  
  .reservation-loading {
    padding: 20px;
  }
  
  .empty-reservation {
    text-align: center;
    padding: 20px 0;
    color: #909399;
    font-size: 14px;
  }
  
  .reservation-list {
    .reservation-item {
      margin-bottom: 20px;
      padding: 15px;
      border-radius: 4px;
      background-color: #f8f9fa;
      
      .reservation-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        
        .left {
          display: flex;
          align-items: center;
          
          h3 {
            margin-right: 10px;
          }
          
          .reservation-tags {
            margin-left: 10px;
          }
        }
        
        .right {
          .el-button {
            margin-left: 10px;
          }
        }
      }
      
      .reservation-content {
        .reservation-info {
          .info-item {
            display: flex;
            margin-bottom: 10px;
            font-size: 14px;
            
            .info-label {
              width: 100px;
              color: #909399;
              flex-shrink: 0;
            }
            
            .info-value {
              color: #303133;
              word-break: break-word;
            }
          }
        }
      }
    }
  }
}

.notification-container {
  display: flex;
  align-items: center;
  margin-right: 20px;
  position: relative;
}

.notification-badge {
  margin-right: 10px;
}

/* 覆盖Element UI的徽章样式 */
::v-deep .el-badge__content.is-fixed {
  top: 5px;
  right: 5px;
  font-size: 12px;
  font-weight: bold;
  height: 18px;
  line-height: 18px;
  min-width: 18px;
  padding: 0 6px;
  background-color: #f56c6c;
  border: 1px solid #fff;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  z-index: 10;
}

.notification-btn {
  padding: 0;
  background: rgba(245, 247, 250, 0.7);
  border: none;
  cursor: pointer;
  height: 42px;
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  border-radius: 50%;
  position: relative;
}

.notification-btn:hover {
  background-color: #ebeef5;
  transform: scale(1.05);
}

.notification-btn i {
  font-size: 22px;
  color: #606266;
}

.notification-btn:hover i {
  color: #409EFF;
}
</style> 